import { render, staticRenderFns } from "./SidebarLeft.vue?vue&type=template&id=5872c615&"
import script from "./SidebarLeft.vue?vue&type=script&lang=js&"
export * from "./SidebarLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports